//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
export default {
  mixins: [dialog],
  name: 'SuggestIntegration',
  components: {
    TeDialog: TeDialog
  },
  props: {
    callback: {
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      integration: ''
    };
  },
  methods: {
    confirmIntegration: function confirmIntegration() {
      var _this = this;

      this.$refs.form.validate().then(function (result) {
        if (result) {
          _this.callback(_this.integration);

          _this.$refs.dialog.hide();
        }
      }).catch(function () {});
    }
  }
};